import React, { useState, useEffect } from 'react';
import styled from 'astroturf/react';

import { ButtonLink } from 'js/design_system/link/ButtonLink';
import Modal from 'js/components/modals/Modal';
import ReaderMessageForm, {
  fetchReaderMessageLimit,
} from 'js/core_webpack/sitewide_business_elements/download/reader_message_form.wjs.jsx';
import { Work } from 'js/liswp/types';
import { UserWithThumbnail } from 'js/core_post_webpack/models/user';

const ReasonsForDownloadingModal = styled(Modal)`
  width: 700px;
  padding: 0;
`;

// Hacky solution to address a width issue with the button
const DownloadButtonContainer = styled('div')`
  width: calc(100% - 64px);
`;

type Props = {
  author: UserWithThumbnail | null;
  downloadUrl: string;
  reactionPrompt?: string;
  work: Work | null;
  displayClass: string;
  attachmentId: number;
  loggedIn: boolean;
};

const DownloadButton = ({
  author,
  downloadUrl,
  reactionPrompt,
  work,
  displayClass,
  attachmentId,
  loggedIn,
}: Props) => {
  const [readerMessageLimitReached, setReaderMessageLimitReached] =
    useState<boolean>(true);
  const [modalShown, setModalShown] = useState<boolean>(false);

  useEffect(() => {
    let cancelled = false;
    setReaderMessageLimitReached(true);
    if (!work || !loggedIn) return;

    fetchReaderMessageLimit(work.id)
      .then((limitReached: boolean) => {
        if (!cancelled) setReaderMessageLimitReached(limitReached);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [work, attachmentId, loggedIn]);

  const handleDownloadClick = () => {
    if (loggedIn && !readerMessageLimitReached && work && author) {
      setModalShown(true);
    }
  };

  return (
    <DownloadButtonContainer>
      <ButtonLink
        className={displayClass}
        onClick={handleDownloadClick}
        href={downloadUrl}
        icon="download"
      >
        Download
      </ButtonLink>
      {modalShown && work && author && (
        <ReasonsForDownloadingModal onClose={() => setModalShown(false)}>
          <ReaderMessageForm
            primaryAuthor={{
              displayName: author.display_name,
              photo: author.photo,
            }}
            workId={work.id}
            attachmentId={attachmentId}
            reactionPrompt={reactionPrompt}
            readerMessageSource="single-article-page"
            showMessageToast={false}
            setReaderMessageLimitReached={setReaderMessageLimitReached}
            closeModal={() => {
              setModalShown(false);
            }}
          />
        </ReasonsForDownloadingModal>
      )}
    </DownloadButtonContainer>
  );
};

export default DownloadButton;
